import { Component } from '@angular/core';

/**
 * Styled with:
 * - --overlay-spinner-overlay-background: background color of the overlay
 * - --overlay-spinner-spinner-background: background color of the spinner
 * - --overlay-spinner-spinner-foreground: foreground color of the spinner
 */
@Component({
  selector: 'yat-overlay-spinner',
  templateUrl: './overlay-spinner.component.html',
  styleUrls: ['./overlay-spinner.component.scss']
})
export class OverlaySpinnerComponent {}
